import { Select as BriqCommonSelect } from '@briq/shared'

export type SelectVariants = BriqCommonSelect.SelectVariants
export type SelectOption = BriqCommonSelect.SelectOption
export type AntLabeledValue = BriqCommonSelect.AntLabeledValue

export const Option = BriqCommonSelect.Option
export const OptionGroup = BriqCommonSelect.OptionGroup

export type SelectProps = BriqCommonSelect.SelectProps

export const Select = BriqCommonSelect.Select
